import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout'
import CheckoutsList from './CheckoutsList'

const resource = {
  list: CheckoutsList,
  icon: ShoppingCartCheckoutIcon
}

export default resource
